/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Input,
  Tabs,
  Menu,
  Modal,
  Checkbox,
  Progress,
  notification,
  Tag,
  Select as AntSelect,
} from 'antd';
import {
  FileExcelOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  RedoOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';

import ExcelJS from 'exceljs';
import { formatReceivedValues } from 'utils/formatValues';
import HTTP, { baseURL } from 'utils/api';
import { onAlert, onError } from 'utils/handlers';
import Table from 'components/Table';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import makeMessager from 'utils/complexFormsMessages';
import FormSubmitControls from 'components/FormSubmitControls';
import useSeguimientoDeRegistro from 'hooks/useSeguimientoDeRegistro';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import Dragger from 'components/Dragger';
import {
  getEstadosGlobales,
} from 'api/catalogos/index';
import {
  getIncidenciasEmpleadosOptimized,
  postIncidenciaEmpleado,
  deleteIncidenciaEmpleado,
  patchIncidenciaEmpleado,
  getIncidenciaEmpleado,
} from 'api/nominas/incidencias/incidenciasEmpleados';
import { getAdministracionDePlazas, getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getConfiguracionIncidencias } from 'api/nominas/incidencias/configuracionIncidencias';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import { getEmpleado, getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { getModelPermission } from 'utils/permission';
import { getPlazas, getPlazasvistaOptimized, getPlazavistaOptimized } from 'api/catalogos/plazas';
import { getPuesto, getPuestos } from 'api/catalogos/puestos';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
  FLOAT_NUMER_PATTERN,
} from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_INACTIVO,
  INCIDENCIA_AUSENTISMO,
  INCIDENCIA_INCAPACIDAD,
  INCIDENCIA_PAGOLABORAL,
} from 'utils/constants';
import CRUDgeneric from 'utils/CRUDgeneric';
import moment from 'moment';
import { getDatoOperacionalesDeEmpleados, getDatoOperacionalPorEmpleado } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getDatoOperacionalPorBecario } from 'api/estructuraOrganizacional/datosOperacionalesDeBecario';
import { getDatoOperacionalPorHonorarioAsimilado } from 'api/estructuraOrganizacional/datosOperacionalesDeHonorarioAsimilado';
import { getBecario, getBecarioVistaoptimizado } from 'api/catalogos/Becario';
import { getHonorarioAsimilado, getHonorarioAsimiladoVistaoptimizado } from 'api/catalogos/HonorarioAsimilado';
import { getTipoDeNominaEmpleado, getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import Adjuntos from 'components/Nominas/Descuentos/Adjuntos';
import DatosInformativos from 'components/Nominas/Descuentos/DatosInformativos';
import ReporteRecurrenteModal, { FORMATO_MONEDA } from 'components/ReporteRecurrenteModal';
import ReporteMovimientosModal from 'components/ReporteMovimientosModal';
import IncidenciasEmpleadosDetalles, { incidenciasEmpleadosDetallesPermission } from './IncidenciasEmpleadosDetalles';
import DatosInformativosIncidencias from './DatosInformativosIncidencias';
import AdjuntosIncidencias from './AdjuntosIncidencias';
import RegistroAltaIMSS from './RegistroAltaIMSS';

const { TabPane } = Tabs;

const DESCRIPCION_PROCESO_CAMBIO_ESTADOS = 'Cambiar Estado Incidencia Empleado';
const DESCRIPCION_PROCESO_IMPORTAR_INCAPACIDADES = 'Importar Incidencias Incapacidades';
const DESCRIPCION_PROCESO_IMPORTAR_PERMISOS = 'Importar Incidencias Permisos';
const baseURI = 'nominas/incidencias-empleados-importar-excel';
const baseURIPermisos = 'nominas/incidencias-permisos-empleados-importar-excel';

const SUJETO_EMPLEADO = 'empleado';
const SUJETO_BECARIO = 'becario';
const SUJETO_HONORARIO_ASIMILADO = 'honorarioasimilado';

const SUJETO_OPCIONES = [
  { slug: SUJETO_EMPLEADO, etiqueta: 'Empleado' },
  { slug: SUJETO_BECARIO, etiqueta: 'Becario' },
  { slug: SUJETO_HONORARIO_ASIMILADO, etiqueta: 'Honorario Asimilado' },
];

const SUJETO_FK = {
  [SUJETO_EMPLEADO]: 'empleado',
  [SUJETO_BECARIO]: 'becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'honorario_asimilado',
};

const SUJETO_LABEL_PERSONA = {
  [SUJETO_EMPLEADO]: 'No. y Nombre del Empleado',
  [SUJETO_BECARIO]: 'No. y Nombre del Becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'No. y Nombre del Honorario Asimilado',
};
const SUJETO_ETIQUETA = {
  [SUJETO_EMPLEADO]: 'Empleado',
  [SUJETO_BECARIO]: 'Becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'Honorario Asimilado',
};
const SUJETO_LABEL_PROP = {
  [SUJETO_EMPLEADO]: 'numero_y_nombre_completo',
  [SUJETO_BECARIO]: 'becario_numero_y_nombre_completo',
  [SUJETO_HONORARIO_ASIMILADO]: 'honorario_asimilado_numero_y_nombre_completo',
};
const GET_PERSONAS_POR_SUJETO = {
  [SUJETO_EMPLEADO]: getEmpleadosOptimized,
  [SUJETO_BECARIO]: getBecarioVistaoptimizado,
  [SUJETO_HONORARIO_ASIMILADO]: getHonorarioAsimiladoVistaoptimizado,
};
const GET_PERSONA_POR_SUJETO = {
  [SUJETO_EMPLEADO]: getEmpleado,
  [SUJETO_BECARIO]: getBecario,
  [SUJETO_HONORARIO_ASIMILADO]: getHonorarioAsimilado,
};
const GET_DATO_OP_POR_SUJETO = {
  [SUJETO_EMPLEADO]: getDatoOperacionalPorEmpleado,
  [SUJETO_BECARIO]: getDatoOperacionalPorBecario,
  [SUJETO_HONORARIO_ASIMILADO]: getDatoOperacionalPorHonorarioAsimilado,
};

const EXCEL_AZUL_OSCURO = 'FF1F3864';
const EXCEL_BLANCO = 'FFFFFFFF';

const estiloEncabezadoExcel = () => ({
  font: {
    name: 'Calibri', size: 11, bold: true, color: { argb: EXCEL_BLANCO },
  },
  fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: EXCEL_AZUL_OSCURO } },
  alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
  border: {
    left: { style: 'thin' },
    right: { style: 'thin' },
    top: { style: 'thin' },
    bottom: { style: 'thin' },
  },
});

const descargarWorkbookExcel = async (workbook, nombreArchivo) => {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nombreArchivo;
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  URL.revokeObjectURL(url);
};

export const incidenciasPermission = {
  permissionModel: 'incidenciaempleado',
  catalogsModels: [],
  tabsModels: [],
};

const IncidenciaEmpleado = ({ permission }) => {
  const [form] = Form.useForm();
  const [formCarga] = Form.useForm();
  const [formCargaPermisos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState('incidencia');
  const [refreshDiasKey, setRefreshDiasKey] = useState(0);
  const [mutable, setMutable] = useState(true);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [plazas, setPlazas] = useState();
  const [plaza, setPlaza] = useState();
  const [area, setArea] = useState();
  const [puestos, setPuestos] = useState();
  const [puesto, setPuesto] = useState();
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [incidencias, setIncidencias] = useState([]);
  const [showReporteIncidencias, setShowReporteIncidencias] = useState(false);
  const [showReporteAusentismo, setShowReporteAusentismo] = useState(false);
  const [incidenciasFiltered, setIncidenciasFiltered] = useState([]);
  const [selectedTipoIncidencia, setSelectedTipoIncidencia] = useState();
  const [selectedIncidencia, setSelectedIncidencia] = useState();
  const [tipoDeEmpleado, setTipoDeEmpleado] = useState();
  const [requirePeriodo, setRequirePeriodo] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalPermisos, setVisibleModalPermisos] = useState(false);
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [isBlocked, setIsBlocked] = useState(false);
  // Estatus del registro abierto en el formulario de edición (Autorizada/Cancelada => solo lectura).
  const [estadoRegistro, setEstadoRegistro] = useState();
  const [nominaDisplay, setNominaDisplay] = useState();
  // Id de Tipo de Nómina Empleado elegido manualmente cuando el empleado no
  // tiene Plaza asignada (p.ej. está de Baja) y por lo tanto no hay un valor
  // que resolver automáticamente desde la Plaza.
  const [tipoNominaManualId, setTipoNominaManualId] = useState();
  // Id de Tipo de Nómina Empleado real del empleado, sin importar si viene de
  // su Plaza o de la selección manual -- se pasa al detalle de la incidencia
  // para filtrar la "Nómina de Aplicación" al calendario de periodos correcto
  // y evitar que se seleccione, por error, un periodo de otro Tipo de Nómina.
  const [tipoNominaEmpleadoId, setTipoNominaEmpleadoId] = useState();
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [selectedEmpleado, setSelectedEmpleado] = useState();
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();
  const [tipoNominaEmpleadoDescripcion, setTipoNominaEmpleadoDescripcion] = useState('');
  const [antiguedadTexto, setAntiguedadTexto] = useState('');
  const [antiguedadDias, setAntiguedadDias] = useState('');
  const [aplicaAntiguedad, setAplicaAntiguedad] = useState(false);
  const [sueldoDiarioBase, setSueldoDiarioBase] = useState(0);
  const [horasJornadaBase, setHorasJornadaBase] = useState(8);
  const [sueldoPorHoraBase, setSueldoPorHoraBase] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [configuracionSeleccionada, setConfiguracionSeleccionada] = useState(null);
  // La pantalla abre en "Todos" (primer tab).
  const [tabListaActiva, setTabListaActiva] = useState('todos');
  const [currentTableData, setCurrentTableData] = useState([]);
  const [isPollingCambioEstados, setIsPollingCambioEstados] = useState(false);
  const [progresoCambioEstados, setProgresoCambioEstados] = useState({ en_curso: 0, total: 0 });
  const pollingCambioEstadosRef = useRef(null);
  const [isPollingImportIncapacidades, setIsPollingImportIncapacidades] = useState(false);
  const [progresoImportIncapacidades, setProgresoImportIncapacidades] = useState({ en_curso: 0, total: 0 });
  const pollingImportIncapacidadesRef = useRef(null);
  const [isPollingImportPermisos, setIsPollingImportPermisos] = useState(false);
  const [progresoImportPermisos, setProgresoImportPermisos] = useState({ en_curso: 0, total: 0 });
  const pollingImportPermisosRef = useRef(null);
  const [sujetoActivo, setSujetoActivo] = useState(SUJETO_EMPLEADO);
  const [personasDataSource, setPersonasDataSource] = useState([]);

  // `todos: null` -> no se envía `estados_globales` y el API regresa
  // Activas, Autorizadas y Canceladas en una sola petición.
  const TAB_ESTADOS_INCIDENCIAS = {
    activas: 1, autorizadas: 4, canceladas: 5, todos: null,
  };

  // El backend (IncidenciaEmpleadoModelSerializer.to_representation) devuelve
  // `estados_globales` como el objeto anidado completo ({id, descripcion, ...}),
  // no como el id escalar -- mismo patrón ya manejado defensivamente en
  // IncidenciasEmpleadosDetalles.jsx/RegistroAltaIMSS.jsx. Sin normalizar, el
  // <Select> de Estatus (que compara contra `estados` por id escalar) nunca
  // encuentra coincidencia y se muestra vacío, y las comparaciones por
  // ESTATUS_AUTORIZADO/ESTATUS_CANCELADO (solo-lectura, filtros, etc.) nunca
  // calzan.
  const normalizarEstadosGlobales = (item) => (
    item?.estados_globales?.id ?? item?.estados_globales
  );

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      return values.map((e) => {
        const item = formatReceivedValues(e);

        const adminPlaza = adminPlazas.find((ap) => ap.empleado_id === item?.empleado);
        const empleadoNombre = `${adminPlaza?.numero_de_empleado || ''} - ${adminPlaza?.nombre || ''} ${adminPlaza?.apellido_paterno || ''} ${adminPlaza?.apellido_materno || ''}`.trim();

        return {
          ...item,
          estados_globales: normalizarEstadosGlobales(item),
          incidencia_concepto: item?.incidencia,
          empleado_nombre: item?.empleado,

          // Campos visibles
          nombre_completo: empleadoNombre,
          puesto: adminPlaza?.puesto || '',
          area: adminPlaza?.directorio_area || '',
          plaza_clave: adminPlaza?.clave || '',
        };
      });
    }

    const item = formatReceivedValues(values);
    return {
      ...item,
      estados_globales: normalizarEstadosGlobales(item),
    };
  };

  const getPermission = getModelPermission(
    incidenciasEmpleadosDetallesPermission.permissionModel,
    incidenciasEmpleadosDetallesPermission.catalogsModels,
    incidenciasEmpleadosDetallesPermission.tabsModels,
    false,
  );

  const basicKeys = [
    'incidencia',
    'dias_acumulados',
    'registro_alta',
    'datos',
    'adjuntos',
  ];

  const complexForms = [];

  const formInstances = [
    form,
  ];

  // Recibe la key del tab (no el estado) para que el tab "Todos" (estado null)
  // no caiga por error en el estado del tab anterior.
  const fetchRequestIdRef = useRef(0);

  const fetchData = async (tabKey = tabListaActiva, sujeto = sujetoActivo) => {
    setLoading(true);
    const estadosGlobales = TAB_ESTADOS_INCIDENCIAS[tabKey];
    const queryParams = { sujeto_tipo: sujeto };
    if (estadosGlobales) queryParams.estados_globales = estadosGlobales;
    const _data = await getIncidenciasEmpleadosOptimized(queryParams);
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      fetchRequestIdRef.current += 1;
      const requestId = fetchRequestIdRef.current;
      // La tabla (endpoint optimizado, ya trae empleado/concepto/estatus
      // resueltos) se pinta en cuanto llega, sin esperar a los catálogos que
      // solo usan el modal y el buscador de empleados.
      const dataPromise = getIncidenciasEmpleadosOptimized({ sujeto_tipo: SUJETO_EMPLEADO }).then((_data) => {
        if (mounted && requestId === fetchRequestIdRef.current) {
          setData(_data);
          setLoading(false);
        }
      });
      const [
        _estados,
        _plazas,
        _puestos,
        _adminPlazas,
        _incidencias,
        _datosOperacionales,
        _tipos_de_nominas_empleados,
        _empleados,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPlazasvistaOptimized(),
        getPuestos(),
        getAdministracionDePlazasvistaOptimized(),
        getConfiguracionIncidencias({ content_type_model: SUJETO_EMPLEADO }),
        getDatoOperacionalesDeEmpleados(),
        getTiposDeNominasEmpleados(),
        getEmpleadosOptimized(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setPlazas(_plazas);
        setPuestos(_puestos);
        setAdminPlazas(_adminPlazas);
        setIncidencias(_incidencias);
        setIncidenciasFiltered(_incidencias?.filter((e) => e?.estados_globales === ESTATUS_AUTORIZADO));
        setDatosOperacionales(_datosOperacionales);
        setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
        setPersonasDataSource(_empleados);
      }
      await dataPromise;
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onLoadTipoIncidencia = (value) => {
    if (value === INCIDENCIA_AUSENTISMO || value === INCIDENCIA_PAGOLABORAL) {
      setRequirePeriodo(true);
    } else {
      setRequirePeriodo(false);
    }
  };

  const onCancel = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setVisible(false);
    setAplicaAntiguedad(false);
    setVisibleModal(false);
    setVisibleModalPermisos(false);
    setPuesto();
    setArea();
    setPlaza();
    setTipoDeEmpleado();
    setTipoNominaManualId();
    setTipoNominaEmpleadoId();
    setMutable(true);
    setCurrentTabKey('incidencia');
    setSelectedTipoIncidencia();
    setSelectedIncidencia();
    setSelectedEmpleado();
    setIsBlocked(false);
    setEstadoRegistro();
    setNominaDisplay();
    setConfiguracionSeleccionada(null);
    setSelectedEmpleadoSearch();
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    try {
      setLoading(true);

      const [key] = selectedRowKeys || [];
      const match = responseData || data.find((item) => item?.id === key);

      if (!match?.id) {
        onAlert('Selecciona un registro válido para editar.');
        return;
      }

      // Al abrir por doble clic, responseData trae el registro pero
      // selectedRowKeys puede haber quedado vacío (el doble clic dispara
      // dos clicks que alternan la selección antes del dblclick). Las
      // pestañas de detalle (Incidencia, Registro de Alta, Adjuntos) leen
      // selectedRowKeys[0], así que hay que sincronizarlo con el registro
      // resuelto para que no carguen vacías.
      setSelectedRowKeys([match.id]);
      setSelectedRows([{
        ...match,
        estados_globales: match.estados_globales_id ?? normalizarEstadosGlobales(match),
      }]);

      // Obtener datos del registro (padre)
      const _incidencia = await getIncidenciaEmpleado(match.id);
      if (!_incidencia) return;

      const _incidenciaFormateada = formatReceivedClone(_incidencia);
      setEstadoRegistro(_incidenciaFormateada.estados_globales);

      // Resetear y setear valores del registro padre
      form.resetFields();
      form.setFieldsValue(_incidenciaFormateada);

      // Detectar sujeto del registro
      let sujeto = SUJETO_EMPLEADO;
      if (_incidencia.becario) {
        sujeto = SUJETO_BECARIO;
      } else if (_incidencia.honorario_asimilado) {
        sujeto = SUJETO_HONORARIO_ASIMILADO;
      }
      setSujetoActivo(sujeto);

      // Cargar personas del sujeto si cambió
      const fetchPersonas = GET_PERSONAS_POR_SUJETO[sujeto];
      if (fetchPersonas) {
        const personas = await fetchPersonas();
        setPersonasDataSource(personas);
      }
      // Cargar incidencias filtradas por sujeto
      const _incidenciasSujeto = await getConfiguracionIncidencias({ content_type_model: sujeto });
      setIncidencias(_incidenciasSujeto);
      setIncidenciasFiltered(_incidenciasSujeto?.filter((e) => e?.estados_globales === ESTATUS_AUTORIZADO));

      if (sujeto !== SUJETO_EMPLEADO) {
        // Becario o Honorario Asimilado: usar snapshot del registro
        const personaId = sujeto === SUJETO_BECARIO
          ? _incidencia.becario
          : _incidencia.honorario_asimilado;
        setSelectedEmpleadoSearch({ id: personaId });
        form.setFieldValue(SUJETO_FK[sujeto], personaId);

        setAntiguedadTexto(_incidencia?.antiguedad_texto || '');
        setAntiguedadDias(_incidencia?.antiguedad_numerico_dias || '');

        const puestoSnapshot = _incidencia?.puesto_clave_y_descripcion || '';
        const areaSnapshot = _incidencia?.directorio_de_area_clave_y_nombre || '';
        const plazaSnapshot = _incidencia?.plaza_clave_y_descripcion || _incidencia?.plaza_no || '';
        const tipoEmpleadoSnapshot = _incidencia?.tipo_empleado_descripcion || '';
        const tipoNominaSnapshot = _incidencia?.tipo_de_nomina_empleado_descripcion || '';

        setPuesto(puestoSnapshot);
        setArea(areaSnapshot);
        setPlaza(plazaSnapshot);
        setTipoDeEmpleado(tipoEmpleadoSnapshot);
        setNominaDisplay(tipoNominaSnapshot);
        setTipoNominaManualId(undefined);
        setTipoNominaEmpleadoId(
          _incidencia?.plaza_tipo_de_nomina_empleado
          || _incidencia?.tipo_de_nomina_empleado
          || undefined,
        );
        form.setFieldsValue({
          puesto: puestoSnapshot,
          area: areaSnapshot,
          plaza: plazaSnapshot,
          tipo_de_empleado: tipoEmpleadoSnapshot,
        });
      } else {
        // Igual que en onChangeEmpleado pero usando el empleado del registro
        const empleadoId = _incidencia.empleado;
        setSelectedEmpleado(empleadoId);

        const [_empleado, datoOp] = await Promise.all([
          getEmpleado(empleadoId),
          getDatoOperacionalPorEmpleado(empleadoId),
        ]);

        // Campo de empleado
        setSelectedEmpleadoSearch(_empleado);
        form.setFieldValue(SUJETO_FK[sujeto], empleadoId);

        // Antigüedad: prioriza el snapshot histórico ya congelado en la propia
        // incidencia (anclado a la fecha del evento) sobre el Dato Operacional
        // actual del empleado, que sigue avanzando con el tiempo.
        setAntiguedadTexto(_incidencia?.antiguedad_texto || datoOp?.antiguedad_texto || '');
        setAntiguedadDias(_incidencia?.antiguedad_numerico_dias || datoOp?.antiguedad_numerico_dias || '');

        const puestoSnapshot = _incidencia?.puesto_clave_y_descripcion || '';
        const areaSnapshot = _incidencia?.directorio_de_area_clave_y_nombre || '';
        const plazaSnapshot = _incidencia?.plaza_clave_y_descripcion || _incidencia?.plaza_no || '';
        const tipoEmpleadoSnapshot = _incidencia?.tipo_empleado_descripcion || '';
        const tipoNominaSnapshot = _incidencia?.tipo_de_nomina_empleado_descripcion || '';

        if (puestoSnapshot || areaSnapshot || plazaSnapshot || tipoNominaSnapshot) {
          setPuesto(puestoSnapshot);
          setArea(areaSnapshot);
          setPlaza(plazaSnapshot);
          setTipoDeEmpleado(tipoEmpleadoSnapshot);
          setNominaDisplay(tipoNominaSnapshot);
          setTipoNominaManualId(undefined);
          setTipoNominaEmpleadoId(_incidencia?.plaza_tipo_de_nomina_empleado
            || _incidencia?.tipo_de_nomina_empleado
            || datoOp?.tipo_de_nomina_empleado
            || undefined);

          form.setFieldsValue({
            puesto: puestoSnapshot,
            area: areaSnapshot,
            plaza: plazaSnapshot,
            tipo_de_empleado: tipoEmpleadoSnapshot,
          });
        } else if (!datoOp?.plaza) {
          setPuesto('');
          setArea('');
          setPlaza('');
          setTipoDeEmpleado('');
          setNominaDisplay('');
          setTipoNominaManualId(_incidencia?.tipo_de_nomina_empleado || datoOp?.tipo_de_nomina_empleado || undefined);
          setTipoNominaEmpleadoId(_incidencia?.tipo_de_nomina_empleado || datoOp?.tipo_de_nomina_empleado || undefined);

          form.setFieldsValue({
            puesto: '',
            area: '',
            plaza: '',
            tipo_de_empleado: '',
          });
        } else {
          let plazaInfo = plazas?.find((p) => p.id === datoOp.plaza);
          if (!plazaInfo) {
            plazaInfo = await getPlazavistaOptimized(datoOp.plaza);
          }

          let puestoStr = '';
          const puestoId = plazaInfo?.puesto_id || plazaInfo?.puesto;
          if (puestoId) {
            const puestoMatch = puestos?.find((p) => p.id === puestoId);
            if (puestoMatch) {
              puestoStr = `${puestoMatch.clave} - ${puestoMatch.descripcion}`;
            } else {
              const _puestoCompleto = await getPuesto(puestoId);
              puestoStr = _puestoCompleto
                ? `${_puestoCompleto?.clave} - ${_puestoCompleto?.descripcion}`
                : '';
            }
          } else {
            puestoStr = plazaInfo?.puesto_descripcion || plazaInfo?.puesto || '';
          }

          const areaStr = plazaInfo?.directorio_area_clave_y_nombre || plazaInfo?.directorio_area || '';
          const plazaStr = plazaInfo?.clave_y_descripcion || plazaInfo?.clave || '';
          const tipoEmpleado = plazaInfo?.tipo_de_empleado;

          const tipoNominaDescripcion = tiposDeNominaEmpleado.find(
            (t) => t.id === plazaInfo?.tipo_nomina_empleado,
          )?.descripcion || plazaInfo?.tipo_nomina_empleado || '';

          setPuesto(puestoStr);
          setArea(areaStr);
          setPlaza(plazaStr);
          setTipoDeEmpleado(tipoEmpleado);
          setNominaDisplay(tipoNominaDescripcion);
          setTipoNominaManualId(undefined);
          setTipoNominaEmpleadoId(datoOp?.tipo_de_nomina_empleado || undefined);

          form.setFieldsValue({
            puesto: puestoStr,
            area: areaStr,
            plaza: plazaStr,
            tipo_de_empleado: tipoEmpleado,
          });
        }
      }

      // Configuración de incidencia para detalle
      const _tipoIncidencia = incidencias.find((e) => e.id === _incidencia?.incidencia);
      setConfiguracionSeleccionada(_tipoIncidencia);
      setSelectedTipoIncidencia(_tipoIncidencia?.tipo_de_incidencia_unidad);
      setSelectedIncidencia(_incidencia?.incidencia);
      onLoadTipoIncidencia(_tipoIncidencia?.tipo_de_incidencia);

      setAplicaAntiguedad(_tipoIncidencia?.aplica_antiguedad || false);

      setVisible(true);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      if (!nominaDisplay && !tipoNominaManualId) {
        onAlert('El campo Tipo de Nómina de Empleado es obligatorio (no tiene Plaza asignada).');
        setLoading(false);
        return;
      }
      const values = {
        ...form.getFieldsValue(),
        tipo_de_nomina_empleado: tipoNominaManualId || null,
      };
      // Limpiar los FKs de los otros sujetos (solo enviar el activo)
      Object.values(SUJETO_FK).forEach((fk) => { delete values[fk]; });
      // Prioriza el id resuelto vía la API (selectedEmpleadoSearch, siempre un
      // escalar numérico limpio) sobre el valor crudo del Form -- el <Select>
      // de persona a veces deja en el Form el texto mostrado ("123 - NOMBRE")
      // en vez del id, lo que el backend rechaza con "se esperaba clave
      // primaria y se recibió str".
      const personaIdForm = form.getFieldValue(SUJETO_FK[sujetoActivo]);
      const personaId = selectedEmpleadoSearch?.id
        || (typeof personaIdForm === 'object' ? personaIdForm?.id : personaIdForm);
      if (personaId) {
        values[SUJETO_FK[sujetoActivo]] = personaId;
      }
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchIncidenciaEmpleado(key, values) : postIncidenciaEmpleado(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        // Antes solo se tomaba selectedRowKeys[0] -- con selección múltiple se
        // eliminaba únicamente el primer registro y el resto quedaba intacto sin
        // avisar al usuario (el mensaje de éxito de deleteIncidenciaEmpleado hacía
        // creer que se habían eliminado todos los seleccionados).
        const resultados = await Promise.all(
          selectedRowKeys.map((key) => deleteIncidenciaEmpleado(key)),
        );
        const eliminados = resultados.filter(Boolean).length;
        const noEliminados = resultados.length - eliminados;
        if (noEliminados > 0) {
          notification.warning({
            message: eliminados > 0 ? 'Eliminación parcial' : 'No se pudo eliminar',
            description: `${eliminados} de ${resultados.length} registro(s) fueron eliminados. Los demás no se pudieron eliminar (posiblemente ya fueron utilizados en otro proceso).`,
            placement: 'topRight',
            duration: 10,
          });
        }
        if (eliminados > 0) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const cargarDatosNominaDeRegistro = async (record) => {
    const empId = record.empleado_id ?? record.empleado;
    const _datosOp = datosOperacionales.find((e) => e.empleado === empId);
    const _tipoNominaEmpleado = _datosOp?.tipo_de_nomina_empleado
      ? await getTipoDeNominaEmpleado(_datosOp.tipo_de_nomina_empleado)
      : null;
    setNominaDisplay(_tipoNominaEmpleado?.descripcion || '');
    const bloqueadoPorNomina = _tipoNominaEmpleado ? !_tipoNominaEmpleado.habilitado : false;
    const egId = record.estados_globales_id ?? record.estados_globales;
    const bloqueadoPorAutorizacion = egId === ESTATUS_AUTORIZADO;
    setIsBlocked(bloqueadoPorNomina || bloqueadoPorAutorizacion);
    form.setFieldsValue(record);
  };

  const handleOnRowClick = async (record) => {
    const isSelected = selectedRowKeys.includes(record.id);
    const _keys = isSelected
      ? selectedRowKeys.filter((id) => id !== record.id)
      : [...selectedRowKeys, record.id];
    const _rows = isSelected
      ? selectedRows.filter((row) => row.id !== record.id)
      : [...selectedRows, record];

    setSelectedRowKeys(_keys);
    setSelectedRows(_rows);

    // Solo cuando queda exactamente un registro seleccionado se precargan
    // los datos de nómina (para edición y bloqueo por nómina cerrada).
    if (_keys.length === 1) {
      const unico = _rows[0];
      await cargarDatosNominaDeRegistro(unico);
    } else {
      setNominaDisplay('');
      setIsBlocked(false);
    }
  };

  const onChangeTabLista = (newTab) => {
    setTabListaActiva(newTab);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setCurrentTableData([]);
    fetchData(newTab, sujetoActivo);
  };

  const onChangeSujeto = async (slug) => {
    setSujetoActivo(slug);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setCurrentTableData([]);
    const fetchPersonas = GET_PERSONAS_POR_SUJETO[slug];
    if (fetchPersonas) {
      const personas = await fetchPersonas();
      setPersonasDataSource(personas);
    }
    const _incidencias = await getConfiguracionIncidencias({ content_type_model: slug });
    setIncidencias(_incidencias);
    setIncidenciasFiltered(_incidencias?.filter((e) => e?.estados_globales === ESTATUS_AUTORIZADO));
    fetchData(tabListaActiva, slug);
  };

  // true si hay selección y TODOS los registros seleccionados están en alguno
  // de los estados permitidos. Controla los botones por estatus (necesario en
  // el tab "Todos", donde conviven registros de distintos estados).
  const seleccionEnEstados = (estadosPermitidos) => selectedRows.length > 0
    && selectedRows.every((row) => estadosPermitidos.includes(
      row.estados_globales_id ?? row.estados_globales,
    ));

  const effectiveData = currentTableData.length ? currentTableData : data;

  const rowSelection = {
    selectedRowKeys,
    type: 'checkbox',
    columnTitle: (
      <Checkbox
        checked={selectedRowKeys.length > 0 && selectedRowKeys.length === effectiveData.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < effectiveData.length}
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedRowKeys(effectiveData.map((row) => row.id));
            setSelectedRows([...effectiveData]);
          } else {
            setSelectedRowKeys([]);
            setSelectedRows([]);
          }
        }}
      />
    ),
    onSelect: (record, selected) => {
      if (selected) {
        setSelectedRowKeys((prev) => [...prev, record.id]);
        setSelectedRows((prev) => [...prev, record]);
      } else {
        setSelectedRowKeys((prev) => prev.filter((key) => key !== record.id));
        setSelectedRows((prev) => prev.filter((row) => row.id !== record.id));
      }
    },
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
  };

  const handleTableChange = (_p, _f, _s, extra) => {
    if (extra?.currentDataSource) {
      setCurrentTableData(extra.currentDataSource);
    }
  };

  const onClickAdd = () => {
    onCancel();
    setCurrentTabKey('incidencia');
    form.setFieldsValue({
      fecha_captura: moment(new Date().getDate(), 'DD/MM/YYYY'),
    });
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const showMsg = makeMessager(setCurrentTabKey);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );
  const onChangeEmpleado = async (val) => {
    const empleadoId = typeof val === 'object' ? val?.id : val;

    // Limpieza si no hay empleado seleccionado
    if (!empleadoId) {
      form.resetFields([
        'puesto', 'area', 'tipo_de_empleado', 'plaza',
        'sueldo_diario', 'numero_horas_jornada', 'sueldo_por_hora',
      ]);
      setNominaDisplay('');
      setPuesto('');
      setArea('');
      setPlaza('');
      return;
    }

    try {
    // 1. Obtener Persona y Dato Operacional (según tipo de sujeto)
      const fetchPersona = GET_PERSONA_POR_SUJETO[sujetoActivo];
      const fetchDatoOp = GET_DATO_OP_POR_SUJETO[sujetoActivo];
      const [empleado, datoOp] = await Promise.all([
        fetchPersona(empleadoId),
        fetchDatoOp(empleadoId),
      ]);

      if (!empleado) {
        // El empleado resuelto ya no existe/está dado de baja (p.ej. dos
        // registros de Empleado comparten el mismo número por un reingreso
        // mal migrado). No dejar datos de Puesto/Área/Plaza a medias en
        // pantalla, que aparentarían un guardado correcto pero fallarían al
        // enviar "empleado" vacío al backend.
        form.resetFields([
          SUJETO_FK[sujetoActivo], 'puesto', 'area', 'tipo_de_empleado', 'plaza',
          'sueldo_diario', 'numero_horas_jornada', 'sueldo_por_hora',
        ]);
        setSelectedEmpleadoSearch();
        setNominaDisplay('');
        setPuesto('');
        setArea('');
        setPlaza('');
        onAlert(`El ${SUJETO_ETIQUETA[sujetoActivo].toLowerCase()} seleccionado ya no está activo.`);
        return;
      }

      // Sueldo/horas de jornada vienen del Dato Operacional, independientes
      // de que el empleado tenga o no una Plaza asignada.
      // eslint-disable-next-line no-shadow
      const sueldoDiarioBase = datoOp?.sueldo_diario || 0;
      // eslint-disable-next-line no-shadow
      const horasJornadaBase = datoOp?.total_horas_solo_hrs || 0;

      // Determinación automática: Sueldo Diario / Número de Horas por Jornada
      const sueldoPorHoraCalculado = horasJornadaBase > 0
        ? (sueldoDiarioBase / horasJornadaBase).toFixed(2)
        : 0;

      setSueldoDiarioBase(sueldoDiarioBase);
      setHorasJornadaBase(horasJornadaBase);
      setSueldoPorHoraBase(sueldoPorHoraCalculado);
      setAntiguedadTexto(datoOp?.antiguedad_texto || '');
      setAntiguedadDias(datoOp?.antiguedad_numerico_dias || '');
      setSelectedEmpleadoSearch(empleado);

      if (!datoOp?.plaza) {
        // Empleado sin Plaza asignada (p.ej. está de Baja): se permite
        // continuar la captura de la incidencia. Puesto/Área/No. de Plaza
        // quedan vacíos y el Tipo de Nómina Empleado se selecciona
        // manualmente (ver bloque de render), precargado con el valor que
        // ya tuviera guardado el Dato Operacional, si existe.
        setPuesto('');
        setArea('');
        setPlaza('');
        setTipoDeEmpleado('');
        setNominaDisplay('');
        setTipoNominaManualId(datoOp?.tipo_de_nomina_empleado || undefined);
        setTipoNominaEmpleadoId(datoOp?.tipo_de_nomina_empleado || undefined);

        form.setFieldsValue({
          puesto: '',
          area: '',
          plaza: '',
          tipo_de_empleado: '',
          sueldo_diario: sueldoDiarioBase,
          numero_horas_jornada: horasJornadaBase,
          sueldo_por_hora: sueldoPorHoraCalculado,
        });
        return;
      }

      // 2. Lógica de Plaza (Existente)
      let plazaInfo = plazas?.find((p) => p.id === datoOp.plaza);
      if (!plazaInfo) {
        plazaInfo = await getPlazavistaOptimized(datoOp.plaza);
      }

      // 3. Obtener Puesto Completo (Existente)
      let puestoStr = '';
      const puestoId = plazaInfo?.puesto_id || plazaInfo?.puesto;

      if (puestoId) {
        const puestoMatch = puestos?.find((p) => p.id === puestoId);
        if (puestoMatch) {
          puestoStr = `${puestoMatch.clave} - ${puestoMatch.descripcion}`;
        } else {
          const _puestoCompleto = await getPuesto(puestoId);
          puestoStr = _puestoCompleto
            ? `${_puestoCompleto?.clave} - ${_puestoCompleto?.descripcion}`
            : '';
        }
      } else {
        puestoStr = plazaInfo?.puesto_descripcion || plazaInfo?.puesto || '';
      }

      // 4. Construir Área, Plaza y Tipo de Nómina
      const areaStr = plazaInfo?.directorio_area_clave_y_nombre || plazaInfo?.directorio_area || '';
      const plazaStr = plazaInfo?.clave_y_descripcion || plazaInfo?.clave || '';
      const tipoEmpleado = plazaInfo?.tipo_de_empleado;

      const tipoNominaDescripcion = tiposDeNominaEmpleado.find(
        (t) => t.id === plazaInfo?.tipo_nomina_empleado,
      )?.descripcion || plazaInfo?.tipo_nomina_empleado || '';

      // 5. Actualizar Estados Locales
      setPuesto(puestoStr);
      setArea(areaStr);
      setPlaza(plazaStr);
      setTipoDeEmpleado(tipoEmpleado);
      setNominaDisplay(tipoNominaDescripcion);
      setTipoNominaManualId(undefined);
      // OJO: plazaInfo.tipo_nomina_empleado (vista optimizada) trae la
      // DESCRIPCIÓN ("NOMINA EVENTUALES"), no el id -- el id numérico real
      // viene de datoOp.tipo_de_nomina_empleado (FK plano del serializer).
      setTipoNominaEmpleadoId(datoOp?.tipo_de_nomina_empleado || undefined);

      // 6. Actualizar Formulario con TODOS los campos,
      form.setFieldsValue({
        puesto: puestoStr,
        area: areaStr,
        plaza: plazaStr,
        tipo_de_empleado: tipoEmpleado,
        sueldo_diario: sueldoDiarioBase,
        numero_horas_jornada: horasJornadaBase,
        sueldo_por_hora: sueldoPorHoraCalculado,
      });
    } catch (error) {
      onAlert('Ocurrió un error al buscar los datos del empleado.');
    }
  };

  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationCancelarVisible, setConfirmationCancelarVisible] = useState(false);

  const clienteAutorizar = CRUDgeneric('/nominas/autorizar-incidencia-empleado/');
  const [confirmationReactivarVisible, setConfirmationReactivarVisible] = useState(false);
  const [confirmationReactivarEmpleadoVisible, setConfirmationReactivarEmpleadoVisible] = useState(false);

  // Autorización masiva de uno o más registros seleccionados.
  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      if (!selectedRowKeys.length) {
        setLoading(false);
        onAlert('Selecciona al menos un registro para autorizar.');
        return;
      }
      const ids = selectedRowKeys.map((id) => ({ id }));
      const response = await HTTP.put(
        `/nominas/autorizar-incidencia-empleado/${ESTATUS_AUTORIZADO}/`,
        ids,
      );
      if (response?.status === 202) {
        setConfirmationVisible(false);
        setIsPollingCambioEstados(true);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Cancelación masiva de uno o más registros seleccionados.
  const handleOnFinishCancelar = async () => {
    try {
      setLoading(true);
      if (!selectedRowKeys.length) {
        setLoading(false);
        onAlert('Selecciona al menos un registro para cancelar.');
        return;
      }
      const ids = selectedRowKeys.map((id) => ({ id }));
      const response = await HTTP.put(
        `/nominas/autorizar-incidencia-empleado/${ESTATUS_CANCELADO}/`,
        ids,
      );
      if (response?.status === 202) {
        setConfirmationCancelarVisible(false);
        setIsPollingCambioEstados(true);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Reactivación masiva: regresa los registros seleccionados a estado Activo.
  const handleOnFinishReactivar = async () => {
    try {
      setLoading(true);
      if (!selectedRowKeys.length) {
        setLoading(false);
        onAlert('Selecciona al menos un registro para reactivar.');
        return;
      }
      const ids = selectedRowKeys.map((id) => ({ id }));
      const response = await HTTP.put(
        `/nominas/autorizar-incidencia-empleado/${ESTATUS_ACTIVO}/`,
        ids,
      );
      if (response?.status === 202) {
        setConfirmationReactivarVisible(false);
        setIsPollingCambioEstados(true);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Reactivación manual del estatus del empleado (no de la incidencia): regresa
  // estado_del_empleado_id al valor previo a la suspensión por incidencia.
  const handleOnFinishReactivarEmpleado = async () => {
    try {
      setLoading(true);
      if (!selectedRowKeys.length) {
        setLoading(false);
        onAlert('Selecciona al menos un registro para reactivar al empleado.');
        return;
      }
      const ids = selectedRowKeys.map((id) => ({ id }));
      const response = await HTTP.put('/nominas/reactivar-empleado-incidencia-empleado/', ids);
      setConfirmationReactivarEmpleadoVisible(false);
      setSelectedRowKeys([]);
      setSelectedRows([]);
      if (response?.data?.errores?.length) {
        notification.warning({
          message: 'Proceso completado con errores',
          description: response.data.errores.slice(0, 5).join(' | '),
          placement: 'topRight',
          duration: 12,
        });
      } else {
        notification.success({
          message: 'Operación completada',
          description: 'El estatus del empleado fue restaurado correctamente.',
          placement: 'topRight',
          duration: 6,
        });
      }
      await fetchData();
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    if (!isPollingCambioEstados) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingCambioEstadosRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_CAMBIO_ESTADOS,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoCambioEstados({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingCambioEstadosRef.current);
          pollingCambioEstadosRef.current = null;
          setIsPollingCambioEstados(false);
          setProgresoCambioEstados({ en_curso: 0, total: 0 });
          setSelectedRowKeys([]);
          setSelectedRows([]);

          if (proceso?.resultado) {
            try {
              const resultado = JSON.parse(proceso.resultado);
              if (resultado.errores && resultado.errores.length > 0) {
                notification.warning({
                  message: 'Proceso completado con errores',
                  description: resultado.errores.slice(0, 5).join(' | '),
                  placement: 'topRight',
                  duration: 12,
                });
              } else {
                notification.success({
                  message: 'Operación completada',
                  description: 'El cambio de estado de las incidencias finalizó correctamente.',
                  placement: 'topRight',
                  duration: 6,
                });
              }
            } catch (_e) {
              notification.success({ message: 'Operación completada', duration: 6 });
            }
          }
          fetchData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling cambio de estados de incidencias] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingCambioEstadosRef.current) {
        clearInterval(pollingCambioEstadosRef.current);
        pollingCambioEstadosRef.current = null;
      }
    };
  }, [isPollingCambioEstados]);

  // Polling — importación de Incapacidades en background (cada 2s, máx ~11 min)
  useEffect(() => {
    if (!isPollingImportIncapacidades) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingImportIncapacidadesRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_IMPORTAR_INCAPACIDADES,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoImportIncapacidades({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingImportIncapacidadesRef.current);
          pollingImportIncapacidadesRef.current = null;
          setIsPollingImportIncapacidades(false);
          setProgresoImportIncapacidades({ en_curso: 0, total: 0 });

          if (proceso?.resultado) {
            const byteCharacters = atob(proceso.resultado);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Resultado_Importacion_Incapacidades.xlsx';
            link.click();
            URL.revokeObjectURL(url);

            notification.success({
              message: 'Importación completada',
              description: 'La carga de incapacidades finalizó. Se descargó el archivo con el detalle de la carga.',
              placement: 'topRight',
              duration: 6,
            });
          } else if (proceso?.mensaje) {
            notification.error({
              message: 'Importación no realizada',
              description: proceso.mensaje,
              placement: 'topRight',
              duration: 8,
            });
          }
          fetchData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling importación de incapacidades] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingImportIncapacidadesRef.current) {
        clearInterval(pollingImportIncapacidadesRef.current);
        pollingImportIncapacidadesRef.current = null;
      }
    };
  }, [isPollingImportIncapacidades]);

  // Polling — importación de Permisos en background (cada 2s, máx ~11 min)
  useEffect(() => {
    if (!isPollingImportPermisos) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingImportPermisosRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_IMPORTAR_PERMISOS,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoImportPermisos({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingImportPermisosRef.current);
          pollingImportPermisosRef.current = null;
          setIsPollingImportPermisos(false);
          setProgresoImportPermisos({ en_curso: 0, total: 0 });

          if (proceso?.resultado) {
            const byteCharacters = atob(proceso.resultado);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Resultado_Importacion_Permisos.xlsx';
            link.click();
            URL.revokeObjectURL(url);

            notification.success({
              message: 'Importación completada',
              description: 'La carga de permisos finalizó. Se descargó el archivo con el detalle de la carga.',
              placement: 'topRight',
              duration: 6,
            });
          } else if (proceso?.mensaje) {
            notification.error({
              message: 'Importación no realizada',
              description: proceso.mensaje,
              placement: 'topRight',
              duration: 8,
            });
          }
          fetchData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling importación de permisos] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingImportPermisosRef.current) {
        clearInterval(pollingImportPermisosRef.current);
        pollingImportPermisosRef.current = null;
      }
    };
  }, [isPollingImportPermisos]);

  const seguimiento = useSeguimientoDeRegistro({
    contentTypeAppLabel: 'nominas',
    contentTypeModel: 'incidenciaempleado',
    moduloDescripcion: 'Nómina',
    documentoOperativoDescripcion: 'Registro de Incidencias',
    moduloOrigenLabel: 'Registro de Incidencias',
    registros: data,
    seleccionIds: selectedRowKeys,
    registroActivo: open && selectedRowKeys.length
      ? data.find((e) => e.id === selectedRowKeys[0]) || { id: selectedRowKeys[0] }
      : null,
    mutable: true,
    getRegistroLabel: (row) => `Incidencia ${row.id}`,
  });

  const columns = [
    {
      titleText: `No. y Nombre de ${SUJETO_ETIQUETA[sujetoActivo]}`,
      dataIndex: 'empleado_nombre',
      key: 'empleado_nombre',
      width: 250,
      render: (val, record) => record.becario_nombre || record.honorario_asimilado_nombre || val,
    },
    {
      titleText: 'Concepto de Incidencia',
      dataIndex: 'incidencia_concepto',
      key: 'incidencia_concepto',
      width: 200,
    },
    {
      titleText: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
      width: 120,
    },
    {
      titleText: 'Unidad de Incidencia',
      dataIndex: 'unidad_de_incidencia',
      key: 'unidad_de_incidencia',
      width: 180,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 200,
    },
    {
      titleText: 'No. de Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado_descripcion',
      key: 'tipo_de_nomina_empleado_descripcion',
      width: 220,
    },
    {
      titleText: `Tipo de ${SUJETO_ETIQUETA[sujetoActivo]}`,
      dataIndex: 'tipo_empleado_descripcion',
      key: 'tipo_empleado_descripcion',
      width: 220,
    },
    {
      titleText: 'Antigüedad',
      dataIndex: 'antiguedad_texto',
      key: 'antiguedad_texto',
      width: 180,
    },
    {
      titleText: 'Periodo',
      dataIndex: 'periodos',
      key: 'periodos',
      width: 250,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 200,
      render: (descripcion, record) => {
        if (!descripcion) return null;
        const egId = record?.estados_globales_id;
        let color = 'blue';
        if (egId === ESTATUS_AUTORIZADO) color = 'green';
        if (egId === ESTATUS_CANCELADO) color = 'red';
        return <Tag color={color}>{descripcion}</Tag>;
      },
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
  };

  // Columnas Sí/No compartidas por ambos layouts (Detectar Periodos Auto,
  // Aplica Dias Habiles/Naturales/Festivos)
  const agregarDropdownSiNo = (ws, rango) => {
    ws.dataValidations.add(rango, {
      type: 'list',
      allowBlank: true,
      formulae: ['"Sí,No"'],
      showErrorMessage: true,
      errorTitle: 'Valor inválido',
      error: 'Seleccione Sí o No de la lista desplegable.',
      showInputMessage: true,
      promptTitle: 'Sí / No',
      prompt: 'Haga clic en la flecha para elegir.',
    });
  };

  // Hoja visible de referencia (Clave + Concepto) para el catálogo de Incidencias
  const agregarHojaCatalogoIncidencias = (workbook, incidenciasCatalogo) => {
    if (incidenciasCatalogo.length === 0) return;
    const wsIncVisible = workbook.addWorksheet('Catálogo Incidencias');
    wsIncVisible.getColumn('A').width = 20;
    wsIncVisible.getColumn('B').width = 60;
    ['A1', 'B1'].forEach((addr, idx) => {
      const cell = wsIncVisible.getCell(addr);
      cell.value = ['Clave', 'Concepto'][idx];
      Object.assign(cell, estiloEncabezadoExcel());
    });
    incidenciasCatalogo.forEach((inc, i) => {
      wsIncVisible.getCell(i + 2, 1).value = inc.clave || '';
      wsIncVisible.getCell(i + 2, 2).value = inc.concepto || '';
    });
  };

  const onClickObtenerPlantilla = async () => {
    try {
      setLoading(true);
      const incidenciasResp = await getConfiguracionIncidencias({
        es_una_incapacidad_medica: true, estados_globales: ESTATUS_AUTORIZADO,
      });
      const incidenciasCatalogo = incidenciasResp?.results || incidenciasResp || [];

      const workbook = new ExcelJS.Workbook();
      const ws = workbook.addWorksheet('Incidencias');

      const encabezados = [
        'Num Empleado', 'Clave de Incidencia', 'Cantidad (Días)', 'Fecha Alta (Expedición)',
        'Fecha Inicial', 'Fecha Final', 'Detectar Periodos Automáticamente (Sí/No)', 'Periodo',
        'Aplica Días Hábiles (Sí/No)', 'Aplica Días Naturales (Sí/No)', 'Aplica Días Festivos (Sí/No)',
        'Días Aplicados al 100', 'Días Aplicados al 50', 'Días Aplicados al 0',
        'Núm. Incapacidad Referencia', 'Resultado',
      ];
      ws.getRow(1).height = 22;
      encabezados.forEach((titulo, idx) => {
        const cell = ws.getCell(1, idx + 1);
        cell.value = titulo;
        Object.assign(cell, estiloEncabezadoExcel());
        ws.getColumn(idx + 1).width = 20;
      });

      // Columnas de fecha (Fecha Alta, Fecha Inicial, Fecha Final)
      for (let fila = 2; fila <= 1000; fila += 1) {
        [4, 5, 6].forEach((col) => {
          ws.getCell(fila, col).numFmt = 'dd/mm/yyyy';
        });
      }

      // Sí/No: Detectar Periodos Auto (G) + Aplica Días Hábiles/Naturales/Festivos (I:K).
      // La columna H (Periodo) queda fuera porque es numérica, no Sí/No.
      agregarDropdownSiNo(ws, 'G2:G1000');
      agregarDropdownSiNo(ws, 'I2:K1000');

      // ── Hoja oculta con el catálogo y la validación desplegable ───────────
      // Clave de Incidencia (columna B) usa la "clave" tal cual, ya que así se
      // compara en la importación (task_importar_incidencias_incapacidades).
      // El número de la columna "Periodo" se cruza en el backend con el tipo de
      // nómina del empleado (no requiere catálogo/dropdown, solo un número).
      if (incidenciasCatalogo.length > 0) {
        const wsCat = workbook.addWorksheet('Catalogos', { state: 'hidden' });
        incidenciasCatalogo.forEach((inc, i) => { wsCat.getCell(i + 1, 1).value = inc.clave || ''; });

        ws.dataValidations.add('B2:B1000', {
          type: 'list',
          allowBlank: true,
          formulae: [`Catalogos!$A$1:$A$${incidenciasCatalogo.length}`],
          showErrorMessage: true,
          errorTitle: 'Clave de Incidencia inválida',
          error: 'Seleccione una clave de la lista desplegable.',
          showInputMessage: true,
          promptTitle: 'Clave de Incidencia',
          prompt: 'Haga clic en la flecha para elegir. Ver hoja "Catálogo Incidencias".',
        });
      }

      // ── Hoja visible de referencia (clave + concepto) ─────────────────────
      agregarHojaCatalogoIncidencias(workbook, incidenciasCatalogo);

      await descargarWorkbookExcel(workbook, 'IncidenciaEmpleadosPlantilla.xlsx');
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickObtenerPlantillaPermisos = async () => {
    try {
      setLoading(true);

      const incidenciasResp = await getConfiguracionIncidencias({
        es_un_permiso: true, estados_globales: ESTATUS_AUTORIZADO,
      });
      const incidenciasCatalogo = incidenciasResp?.results || incidenciasResp || [];

      const workbook = new ExcelJS.Workbook();
      const ws = workbook.addWorksheet('Permisos');

      const encabezados = [
        'Num Empleado', 'Clave de Incidencia', 'Cantidad (Días)', 'Fecha Alta (Expedición)',
        'Fecha Inicial', 'Fecha Final', 'Detectar Periodos Automáticamente (Sí/No)', 'Periodo',
        'Aplica Días Hábiles (Sí/No)', 'Aplica Días Naturales (Sí/No)', 'Aplica Días Festivos (Sí/No)',
        'Resultado',
      ];
      ws.getRow(1).height = 22;
      encabezados.forEach((titulo, idx) => {
        const cell = ws.getCell(1, idx + 1);
        cell.value = titulo;
        Object.assign(cell, estiloEncabezadoExcel());
        ws.getColumn(idx + 1).width = 20;
      });

      // Columnas de fecha (Fecha Alta, Fecha Inicial, Fecha Final)
      for (let fila = 2; fila <= 1000; fila += 1) {
        [4, 5, 6].forEach((col) => {
          ws.getCell(fila, col).numFmt = 'dd/mm/yyyy';
        });
      }

      // Sí/No: Detectar Periodos Auto (G) + Aplica Días Hábiles/Naturales/Festivos (I:K).
      // La columna H (Periodo) queda fuera porque es numérica, no Sí/No.
      agregarDropdownSiNo(ws, 'G2:G1000');
      agregarDropdownSiNo(ws, 'I2:K1000');

      // ── Hoja oculta con la clave de Incidencia y su validación desplegable ─
      if (incidenciasCatalogo.length > 0) {
        const wsCat = workbook.addWorksheet('Catalogos', { state: 'hidden' });
        incidenciasCatalogo.forEach((inc, i) => { wsCat.getCell(i + 1, 1).value = inc.clave || ''; });

        ws.dataValidations.add('B2:B1000', {
          type: 'list',
          allowBlank: true,
          formulae: [`Catalogos!$A$1:$A$${incidenciasCatalogo.length}`],
          showErrorMessage: true,
          errorTitle: 'Clave de Incidencia inválida',
          error: 'Seleccione una clave de la lista desplegable.',
          showInputMessage: true,
          promptTitle: 'Clave de Incidencia',
          prompt: 'Haga clic en la flecha para elegir. Ver hoja "Catálogo Incidencias".',
        });
      }

      // ── Hoja visible de referencia (clave + concepto) ─────────────────────
      agregarHojaCatalogoIncidencias(workbook, incidenciasCatalogo);

      await descargarWorkbookExcel(workbook, 'Permisos_Plantilla.xlsx');
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickCargar = () => {
    setVisibleModal(true);
  };

  const onClickCargarPermisos = () => {
    setVisibleModalPermisos(true);
  };

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
        const response = await HTTP.post(`${baseURL}${uri}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response?.status === 202) {
          setVisibleModal(false);
          formCarga.resetFields();
          setProgresoImportIncapacidades({ en_curso: 0, total: 0 });
          setIsPollingImportIncapacidades(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onUploadPermisos = async () => {
    try {
      await formCargaPermisos.validateFields();
      const { file } = formCargaPermisos.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        const uri = baseURIPermisos.at(-1) === '/' ? baseURIPermisos : `${baseURIPermisos}/`;
        const response = await HTTP.post(`${baseURL}${uri}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response?.status === 202) {
          setVisibleModalPermisos(false);
          formCargaPermisos.resetFields();
          setProgresoImportPermisos({ en_curso: 0, total: 0 });
          setIsPollingImportPermisos(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  // comentario de prueba
  const menuImport = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          text: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantilla(),
        },
        {
          key: 2,
          label: 'Cargar',
          text: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargar(),
        },
      ]}
    />
  );

  const menuImportExtra = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          text: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantillaPermisos(),
        },
        {
          key: 2,
          label: 'Cargar',
          text: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargarPermisos(),
        },
      ]}
    />
  );
  const menuImportExtraPago = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          text: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantillaPermisos(),
        },
        {
          key: 2,
          label: 'Cargar',
          text: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargarPermisos(),
        },
      ]}
    />
  );

  // Autorizadas y Canceladas se muestran en solo lectura (igual que Descuentos de Empleados).
  const esSoloLectura = estadoRegistro === ESTATUS_AUTORIZADO || estadoRegistro === ESTATUS_CANCELADO;
  const bloqueado = isBlocked || esSoloLectura;

  const getControls = () => {
    if (isBlocked) {
      return {
        onClickAdd,
        onClickEdit: (record) => onClickEdit(record),
        onClickDelete: () => onAlert(`El Tipo de Nómina Empleado ${nominaDisplay} se encuentra cerrado`),
      };
    }
    return {
      onClickAdd,
      onClickEdit: (record) => onClickEdit(record),
      onClickDelete,
    };
  };
  useEffect(() => {
    if (selectedEmpleadoSearch) {
      form.setFieldsValue({
        empleado: `${selectedEmpleadoSearch.numero_de_empleado || ''} - ${selectedEmpleadoSearch.nombre || ''} ${selectedEmpleadoSearch.apellido_paterno || ''} ${selectedEmpleadoSearch.apellido_materno || ''}`,
      });
    }
  }, [selectedEmpleadoSearch, form]);

  const handleValuesChange = (changedValues, allValues) => {
    const { numero_horas_jornada, sueldo_diario } = allValues;

    // Si cambiaron las horas o el sueldo, recalculamos el sueldo por hora
    if ('numero_horas_jornada' in changedValues || 'sueldo_diario' in changedValues) {
      const horas = parseFloat(numero_horas_jornada) || 0;
      const sueldo = parseFloat(sueldo_diario) || 0;

      const nuevoSueldoHora = horas > 0 ? (sueldo / horas).toFixed(2) : 0;

      form.setFieldsValue({
        sueldo_por_hora: nuevoSueldoHora,
      });
    }
  };

  // ── Acciones por estatus ──────────────────────────────────────────────
  // Cada acción se habilita solo si TODOS los registros seleccionados están en
  // un estatus válido para ella. Los tabs por estatus muestran únicamente sus
  // acciones; el tab "Todos" muestra todas y el estatus decide cuál aplica.
  const accionAutorizar = {
    onClick: () => setConfirmationVisible(true),
    permission: { model: 'incidenciaempleado', action: 'autorizar' },
    text: 'Autorizar',
    icon: <CheckCircleOutlined />,
    disabledBySelection: true,
    className: 'success',
    disabled: !seleccionEnEstados([ESTATUS_ACTIVO]),
  };

  const accionCancelar = {
    onClick: () => setConfirmationCancelarVisible(true),
    permission: { model: 'incidenciaempleado', action: 'cancelar' },
    text: 'Cancelar',
    icon: <CloseCircleOutlined />,
    className: 'cancel',
    disabledBySelection: true,
    disabled: !seleccionEnEstados([ESTATUS_ACTIVO, ESTATUS_AUTORIZADO]),
  };

  const accionReactivar = {
    onClick: () => setConfirmationReactivarVisible(true),
    permission: { model: 'incidenciaempleado', action: 'reactivar' },
    text: 'Reactivar',
    icon: <RedoOutlined />,
    className: 'success',
    disabledBySelection: false,
    disabled: !seleccionEnEstados([ESTATUS_AUTORIZADO, ESTATUS_CANCELADO]),
  };

  const accionReactivarEmpleado = {
    onClick: () => setConfirmationReactivarEmpleadoVisible(true),
    permission: { model: 'incidenciaempleado', action: 'reactivarempleado' },
    text: 'Reactivar Empleado',
    icon: <UserSwitchOutlined />,
    className: 'success',
    disabledBySelection: false,
    // No se exige ESTATUS_AUTORIZADO: una Incidencia de fecha final fija que
    // se desautoriza/cancela después de haber suspendido al empleado no se
    // restaura sola (ver nota en IncidenciaEmpleadoModelSerializer.update()),
    // así que el botón debe seguir disponible en Activo/Cancelado para ese caso.
    disabled: !seleccionEnEstados([ESTATUS_AUTORIZADO, ESTATUS_ACTIVO, ESTATUS_CANCELADO])
      || selectedRows.some((row) => !row.requiere_reactivar_empleado),
  };

  // Agregar/Importar genera incidencias Activas: solo en "Activas" y "Todos".
  const renderTablaIncidencias = ({
    controls,
    customActions,
    conImportacion = false,
    disableDelete = false,
  }) => (
    seguimiento.conBarra(<Table
      cols={[seguimiento.columnaSeguimiento, ...columns]}
      data={data}
      rowSelection={rowSelection}
      handleOnRowClick={handleOnRowClick}
      controls={controls}
      permission={permission}
      onTableChange={handleTableChange}
      allowExportPDF={false}
      extraExportItems={[{
        key: 'reporte_incidencias',
        label: 'Reporte de Incidencias',
        icon: <FileExcelOutlined />,
        onClick: () => setShowReporteIncidencias(true),
      }, {
        key: 'reporte_ausentismo',
        label: 'Reporte de Ausentismo',
        icon: <FileExcelOutlined />,
        onClick: () => setShowReporteAusentismo(true),
      }]}
      disableDelete={disableDelete}
      customActions={[...(customActions || []), seguimiento.accionSeguimiento]}
      // Autorizar/Cancelar/Reactivar agrupados en un menú "Acciones" para que
      // la barra no ocupe varios renglones y le quite alto a la tabla.
      customActionsDropdown
      customActionsDropdownText="Acciones"
      // Importar Incapacidades/Permisos agrupados en un solo menú "Importar".
      groupImports
      groupImportsText="Importar"
      allowCustomImport={conImportacion}
      customImportMenu={conImportacion ? menuImport : undefined}
      customImportText="Importar Incapacidades"
      allowCustomImportExtra={conImportacion}
      customImportMenuExtra={conImportacion ? menuImportExtra : undefined}
      customImportExtraText="Importar Permisos"
      customImportMenuExtraPago={conImportacion ? menuImportExtraPago : undefined}
      customImportExtraTextPago="Importar Permisos"
      allowImport={conImportacion}
      baseURI={conImportacion ? baseURI : undefined}
    />)
  );

  return (
    // `container` da el height: 100% que necesita el Card `.tables-container`
    // para que la tabla se ajuste al alto de la ventana (igual que en
    // Asignación de Plaza); sin él, el Card crece con los datos.
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Card bordered={false} className="tables-container">
            <Row style={{ marginBottom: 12 }}>
              <Col>
                <span style={{ marginRight: 8, fontWeight: 500 }}>Tipo de Sujeto:</span>
                <AntSelect
                  value={sujetoActivo}
                  onChange={onChangeSujeto}
                  style={{ width: 220 }}
                  options={SUJETO_OPCIONES.map((s) => ({ value: s.slug, label: s.etiqueta }))}
                />
              </Col>
            </Row>
            <Tabs
              activeKey={tabListaActiva}
              onChange={onChangeTabLista}
              items={[
                {
                  key: 'todos',
                  label: 'Todos',
                  // Todas las acciones visibles; cada una se habilita según el
                  // estatus de los registros seleccionados. Eliminar solo aplica
                  // a incidencias Activas.
                  children: renderTablaIncidencias({
                    controls: getControls(),
                    customActions: [
                      accionAutorizar,
                      accionCancelar,
                      accionReactivar,
                      accionReactivarEmpleado,
                    ],
                    conImportacion: true,
                    disableDelete: !seleccionEnEstados([ESTATUS_ACTIVO]),
                  }),
                },
                {
                  key: 'activas',
                  label: 'Activas',
                  children: renderTablaIncidencias({
                    controls: getControls(),
                    customActions: [accionAutorizar, accionCancelar, accionReactivarEmpleado],
                    conImportacion: true,
                  }),
                },
                {
                  key: 'autorizadas',
                  label: 'Autorizadas',
                  children: renderTablaIncidencias({
                    controls: { onClickEdit: (record) => onClickEdit(record) },
                    customActions: [accionCancelar, accionReactivar, accionReactivarEmpleado],
                  }),
                },
                {
                  key: 'canceladas',
                  label: 'Canceladas',
                  children: renderTablaIncidencias({
                    controls: { onClickEdit: (record) => onClickEdit(record) },
                    customActions: [accionReactivar, accionReactivarEmpleado],
                  }),
                },
              ]}
            />
          </Card>
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Registro de Incidencia de ${SUJETO_ETIQUETA[sujetoActivo]}`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                mutable={!esSoloLectura}
              />
            )}
            bordered={false}
          >
            {seguimiento.envolverConSeguimiento(
              <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onValuesChange={handleValuesChange}
                scrollToFirstError
                name="general"
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name={SUJETO_FK[sujetoActivo]}
                      label={SUJETO_LABEL_PERSONA[sujetoActivo]}
                      required
                      hasFeedback
                    >
                      <Select
                        labelProp={SUJETO_LABEL_PROP[sujetoActivo]}
                        dataSource={personasDataSource}
                        onChange={onChangeEmpleado}
                        disabled={esSoloLectura}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Puesto"
                    >
                      <Input
                        allowClear
                        disabled
                        value={puesto}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Área"
                    >
                      <Input
                        allowClear
                        disabled
                        value={area}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label={`Tipo de ${SUJETO_ETIQUETA[sujetoActivo]}`}
                    >
                      <Input
                        disabled
                        value={tipoDeEmpleado}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="No. de Plaza"
                      hasFeedback
                    >
                      <Input
                        allowClear
                        disabled
                        value={plaza}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Tipo de Nómina de Empleado"
                      hasFeedback
                      required={!nominaDisplay}
                      validateStatus={!nominaDisplay && !tipoNominaManualId ? 'error' : undefined}
                      help={!nominaDisplay ? `El ${SUJETO_ETIQUETA[sujetoActivo].toLowerCase()} no tiene Plaza asignada, seleccione manualmente` : undefined}
                    >
                      {nominaDisplay ? (
                        <Input
                          allowClear
                          disabled
                          value={nominaDisplay}
                        />
                      ) : (
                        <Select
                          dataSource={tiposDeNominaEmpleado.filter(
                            (t) => t.content_type_model === sujetoActivo,
                          )}
                          value={tipoNominaManualId}
                          disabled={esSoloLectura}
                          onChange={(value) => {
                            setTipoNominaManualId(value);
                            setTipoNominaEmpleadoId(value);
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="incidencia"
                      label="Concepto de Incidencia"
                      rules={rules.required}
                      hasFeedback
                    >
                      <Select
                        keyProp="id"
                        labelProp="concepto"
                        dataSource={selectedRowKeys.length ? incidencias : incidenciasFiltered}
                        disabled={selectedRowKeys.length > 0}
                        onChange={(value) => {
                        // 1. Buscamos el objeto completo en el array que ya tienes cargado
                          const _incidenciaSeleccionada = incidencias.find((i) => i.id === value);

                          // 2. Guardamos TODA la configuración en el estado para enviarla al detalle
                          setConfiguracionSeleccionada(_incidenciaSeleccionada);

                          // 3. Tus lógicas actuales
                          setSelectedTipoIncidencia(_incidenciaSeleccionada?.tipo_de_incidencia_unidad);
                          setSelectedIncidencia(value);
                          setAplicaAntiguedad(_incidenciaSeleccionada?.aplica_antiguedad || false);

                          if (_incidenciaSeleccionada) {
                            onLoadTipoIncidencia(_incidenciaSeleccionada.tipo_de_incidencia);
                          }
                        }}
                        render={(val) => `${val?.clave} - ${val?.concepto}`}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item label="Antigüedad">
                      <Input
                        disabled
                        value={`${antiguedadTexto || ''}${antiguedadDias ? ` / ${antiguedadDias} días` : ''}`}
                      />
                    </Form.Item>
                  </Col>
                  {/*
                {configuracionSeleccionada?.aplica_porcentaje_de_sueldo && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="porcentaje_pago_sueldo" label="Porcentaje de Pago de Sueldo">
                    <Input suffix="%" type="number" step="0.01" />
                  </Form.Item>
                </Col>
                )}

                {configuracionSeleccionada?.requiere_numero_de_horas_de_la_jornada && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="numero_horas_jornada" label="Número de Horas de la Jornada">
                    <Input type="number" step="0.1" />
                  </Form.Item>
                </Col>
                )}

                {configuracionSeleccionada?.requiere_sueldo_por_dia && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="sueldo_diario" label="Sueldo Diario">
                    <Input prefix="$" disabled value={form.getFieldValue('sueldo_diario_emp')} />
                  </Form.Item>
                </Col>
                )}

                {configuracionSeleccionada?.requiere_sueldo_por_hora && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="sueldo_por_hora" label="Sueldo por Hora">
                    <Input prefix="$" disabled />
                  </Form.Item>
                </Col>
                )}

                {configuracionSeleccionada?.requiere_numero_de_veces_de_pago && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="numero_veces_pago" label="Número de Veces de Pago">
                    <Select
                      dataSource={[
                        { id: 1, descripcion: 'Sencillo' },
                        { id: 2, descripcion: 'Doble' },
                        { id: 3, descripcion: 'Triple' },
                      ]}
                    />
                  </Form.Item>
                </Col>
                )}

                {configuracionSeleccionada?.requiere_importe_de_pago && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="importe_pago" label="Importe de Pago">
                    <Input prefix="$" />
                  </Form.Item>
                </Col>
                )}

                {configuracionSeleccionada?.requiere_importe_de_descuento && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="importe_descuento" label="Importe de Descuento">
                    <Input prefix="$" />
                  </Form.Item>
                </Col>
                )} */}

                  {selectedRowKeys.length
                    ? (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estados_globales"
                          label="Estatus"
                          rules={rules.required}
                          hasFeedback
                        >
                          <Select
                            dataSource={estados}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                    )
                    : (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estados_globales"
                          label="Estatus"
                          rules={rules.required}
                          hasFeedback
                          initialValue={1}
                        >
                          <Select
                            dataSource={estados}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                    )}
                </Row>
                <Tabs
                  activeKey={currentTabKey}
                  onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                  type="card"
                >
                  <TabPane
                    tab="Incidencia"
                    key="incidencia"
                    forceRender
                  >
                    <IncidenciasEmpleadosDetalles
                      permission={getPermission}
                      selected={selectedRowKeys[0]}
                      selectedTipoIncidencia={selectedTipoIncidencia}
                      selectedEmpleado={selectedEmpleado}
                      tipoDeNominaEmpleadoId={tipoNominaEmpleadoId}
                      requirePeriodo={requirePeriodo}
                      selectedIncidencia={selectedIncidencia}
                      isBlocked={bloqueado}
                      aplicaAntiguedad={aplicaAntiguedad}
                      sueldoDiarioBase={sueldoDiarioBase}
                      horasJornadaBase={horasJornadaBase}
                      sueldoPorHoraBase={sueldoPorHoraBase}
                      refreshDiasKey={refreshDiasKey}
                    />
                  </TabPane>
                  <TabPane
                    tab="Días Acumulados"
                    key="dias_acumulados"
                    forceRender
                  >
                    <div style={{ padding: '10px 0' }}>
                      <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 16 }}>
                        DATOS INICIALES
                      </p>

                      <Row gutter={16}>
                        <Col span={24}>
                          <Form.Item
                            name="observaciones"
                            label="Observaciones:"
                          >
                            <Input
                              placeholder="Registrar en los siguientes campos, los días acumulados a los diferentes porcentajes, al 01/enero/2026"
                              disabled
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col xs={24} sm={8}>
                          <Form.Item
                            name="dias_aplicados_al_100"
                            label="Días Acumulados al 100%"
                            hasFeedback
                          >
                            <Input type="number" disabled={bloqueado} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={8}>
                          <Form.Item
                            name="dias_aplicados_al_50"
                            label="Días Acumulados al 50%"
                            hasFeedback
                          >
                            <Input type="number" disabled={bloqueado} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={8}>
                          <Form.Item
                            name="dias_aplicados_al_0"
                            label="Días Acumulados al 0%"
                            hasFeedback
                          >
                            <Input type="number" disabled={bloqueado} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  </TabPane>
                  <TabPane
                    tab="Registro de Alta"
                    key="registro_alta"
                    forceRender
                    disabled={!selectedRowKeys.length}
                  >
                    <RegistroAltaIMSS
                      incidenciaEmpleadoId={selectedRowKeys[0]}
                      isBlocked={bloqueado}
                      permission={getPermission}
                      onAfterAutorizar={() => setRefreshDiasKey((k) => k + 1)}
                    />
                  </TabPane>
                  <TabPane
                    tab="Datos Informativos"
                    key="datos"
                    forceRender
                  >
                    <DatosInformativosIncidencias
                      form={form}
                      rules={rules}
                      isBlocked={bloqueado}
                    />
                  </TabPane>
                  <TabPane
                    tab="Adjuntos"
                    key="adjuntos"
                    forceRender
                    disabled={!selectedRowKeys.length}
                  >
                    <AdjuntosIncidencias
                      permissions={getPermission}
                      selected={selectedRowKeys[0]}
                      isBlocked={bloqueado}
                    />
                  </TabPane>
                </Tabs>
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Form>,
              'esta Incidencia',
            )}
          </Card>
        )}
        {seguimiento.modalSeguimiento}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Registro de Incidencia de ${SUJETO_ETIQUETA[sujetoActivo]}`}
          loading={loading}
        />
        <Modal
          open={visibleModal}
          title={(
            <FormSubmitControls
              label="Carga Masiva"
              onFinish={onUpload}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name="carga"
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={rules.required}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>
        <Modal
          open={visibleModalPermisos}
          title={(
            <FormSubmitControls
              label="Carga Masiva"
              onFinish={onUploadPermisos}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCargaPermisos}
              name="carga"
              onFinish={onUploadPermisos}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={rules.required}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => setConfirmationVisible(false)}
          open={confirmationVisible}
          contentTitle={`Autorizar ${selectedRowKeys.length} incidencia(s) seleccionada(s)`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishCancelar}
          ConfirmAutorize
          onCancel={() => setConfirmationCancelarVisible(false)}
          open={confirmationCancelarVisible}
          contentTitle={`Cancelar ${selectedRowKeys.length} incidencia(s) seleccionada(s)`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setConfirmationReactivarVisible(false)}
          open={confirmationReactivarVisible}
          title="Confirmación"
          contentTitle={`Reactivar ${selectedRowKeys.length} incidencia(s) seleccionada(s)`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishReactivarEmpleado}
          onFinishText="Reactivar Empleado"
          onFinishIcon={<UserSwitchOutlined />}
          onCancel={() => setConfirmationReactivarEmpleadoVisible(false)}
          open={confirmationReactivarEmpleadoVisible}
          title="Confirmación"
          contentTitle={`Reactivar el estatus de ${selectedRowKeys.length} empleado(s) de la(s) incidencia(s) seleccionada(s)`}
          loading={loading}
        />
        <Modal
          open={isPollingCambioEstados}
          title="Procesando..."
          footer={null}
          closable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoCambioEstados.total > 0
                  ? Math.round((progresoCambioEstados.en_curso / progresoCambioEstados.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoCambioEstados.en_curso}
              {' / '}
              {progresoCambioEstados.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>
        <Modal
          open={isPollingImportIncapacidades}
          title="Importando Incapacidades..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoImportIncapacidades.total > 0
                  ? Math.round((progresoImportIncapacidades.en_curso / progresoImportIncapacidades.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoImportIncapacidades.en_curso}
              {' / '}
              {progresoImportIncapacidades.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>
        <Modal
          open={isPollingImportPermisos}
          title="Importando Permisos..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoImportPermisos.total > 0
                  ? Math.round((progresoImportPermisos.en_curso / progresoImportPermisos.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoImportPermisos.en_curso}
              {' / '}
              {progresoImportPermisos.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>
        <ReporteRecurrenteModal
          open={showReporteIncidencias}
          onClose={() => setShowReporteIncidencias(false)}
          tipo="incidencias"
          titulo="Reporte de Incidencias"
          conceptoLabel="Conceptos de Incidencia"
          conceptos={(incidencias || []).map((i) => ({ id: i.id, label: `${i.clave} - ${i.concepto}` }))}
          columnasConcepto={[
            { header: 'Concepto', key: 'concepto', width: 34 },
            { header: 'Tipo de Incidencia', key: 'tipo_de_incidencia', width: 18 },
            // NÓMINA - PAGO / NÓMINA - DESCUENTO / REGISTRO - AUSENTISMO (este último sin importe)
            { header: 'Origen', key: 'origen', width: 24 },
            { header: 'Cantidad', key: 'cantidad', width: 10 },
            { header: 'Unidad', key: 'unidad', width: 10 },
            {
              header: 'Fecha Inicial Incidencia', key: 'fecha_inicial', width: 14, fecha: true,
            },
            {
              header: 'Fecha Final Incidencia', key: 'fecha_final', width: 14, fecha: true,
            },
            {
              header: 'Importe', key: 'importe', width: 15, numFmt: FORMATO_MONEDA,
            },
          ]}
          fileName="Reporte_Incidencias"
        />
        <ReporteMovimientosModal
          open={showReporteAusentismo}
          onClose={() => setShowReporteAusentismo(false)}
          tipo="ausentismo"
          titulo="Reporte de Ausentismo"
          conceptoLabel="Conceptos de Incidencia"
          // Solo conceptos de tipo Ausentismo e Incapacidad. Por defecto: todas las incapacidades y
          // las de ausentismo que descuentan o suspenden el sueldo (faltas, permisos sin goce,
          // licencias...); quedan fuera las que no afectan el pago (día económico, onomástico...).
          conceptos={(incidencias || [])
            .filter((i) => [INCIDENCIA_AUSENTISMO, INCIDENCIA_INCAPACIDAD].includes(i.tipo_de_incidencia))
            .map((i) => ({ id: i.id, label: `${i.clave} - ${i.concepto}` }))}
          conceptosPorDefecto={(incidencias || [])
            .filter((i) => i.tipo_de_incidencia === INCIDENCIA_INCAPACIDAD
              || (i.tipo_de_incidencia === INCIDENCIA_AUSENTISMO
                && (i.aplica_descuento || i.se_suspende_el_pago_de_sueldo)))
            .map((i) => i.id)}
          hojas={[{
            key: 'ausentismo',
            nombre: 'Ausentismo',
            titulo: 'EMPLEADOS CON INCIDENCIAS',
            columnas: [
              { header: 'Concepto', key: 'concepto', width: 40 },
              { header: 'Tipo de Incidencia', key: 'tipo_de_incidencia', width: 16 },
              {
                header: 'Fecha Inicial', key: 'fecha_inicial', width: 13, fecha: true,
              },
              {
                header: 'Fecha Final', key: 'fecha_final', width: 13, fecha: true,
              },
              { header: 'Cantidad', key: 'cantidad', width: 10 },
            ],
          }]}
          nota="Incidencias autorizadas cuyas fechas se cruzan con el periodo. Fecha de Movimiento = fecha de captura; puesto, plaza y área son los de esa fecha."
          fileName="Reporte_Ausentismo"
        />
      </Spin>
    </Row>
  );
};

export default IncidenciaEmpleado;
